import { createContext, useContext } from "react"
import type { TWorkspace, TWorkspaceRole } from "@core/types"

type TWorkspaceContext = {
  workspace: TWorkspace
  role: TWorkspaceRole
  workspaceId: string
}

export const WorkspaceContext = createContext<TWorkspaceContext | null>(null)

export const useWorkspaceContext = (): TWorkspaceContext => {
  const ctx = useContext(WorkspaceContext)
  if (!ctx) {
    throw new Error("useWorkspaceContext must be used inside WorkspaceGuard")
  }
  return ctx
}
